<template lang="pug">
  .property(v-if="! hidden" :class="{ selectable }")
    .label(v-if="property.label && !hideLabel")
      label {{ property.label }}
    .value(v-if="value && type !== 'color'" v-html="value")
    .value(v-else-if="value && type === 'color'")
      // TODO: check for image swatch
      .color-prop(v-if="valueAlt")
        .tile(:style="{ background: valueAlt }")
        span(v-html="value")
      span(v-else v-html="value")
    .options(v-else-if="options")
      button.button.is-small.is-link.option(
        v-for="option in options"
        :class="{ 'is-active': activeOption && activeOption.id === option.id, 'is-not-available': !option.available, 'is-out-of-stock': !option.sellable }"
        :disabled="!valid || !validArticles || !validArticles.length || !option.sellable"
        @click="select(option)"
      )
        template(v-if="type !== 'color'") {{ option.value }}
        template(v-else)
          .color-prop(v-if="option.valueAlt")
            .tile(:style="{ background: option.valueAlt }")
            span {{ option.value }}
          span(v-else) {{ option.value }}
</template>

<script>
import nl2br from 'nl2br';

export default {
    name: 'ProductProperty',
    data: () => ({
        options: []
    }),
    props: {
        property: {
            type: Object,
            required: true
        },
        validArticles: {
            type: Array,
            required: false
        },
        sellableArticles: {
            type: Array,
            required: false
        },
        activeOption: {
            type: Object,
            required: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        },
        manageStock: {
            type: Boolean,
            default: false
        },
        valid: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hidden() {
            return !this.property.options.length;
        },
        selectable() {
            return this.property.options.length > 1;
        },
        type() {
            return this.property.type;
        },
        value() {
            if (this.selectable || this.hidden) return undefined;
            return nl2br(this.property.options[0].value || this.property.options[0].valueAlt);
        },
        valueAlt() {
            if (this.selectable || this.hidden) return undefined;
            return nl2br(this.property.options[0].valueAlt);
        }
    },
    methods: {
        select(option) {
            this.$emit('select', { property: this.property, option });
        }
    },
    mounted() {
        // TODO
        // if not this.activeOption
        // check of there are multiple options (this.selectable)
        // but only one is available
        // trigger the 'select' event for the only option

        if (!this.selectable || this.hidden) return undefined;
        let options = this.property.options;

        options.forEach(option => {
            let sellable = true;
            if (this.property.articleRequired && this.sellableArticles && this.sellableArticles.length) {
                // check if is sellable
                // ---
                // sellable means there is some stock
                // for any article with this property value
                sellable = false;

                const relatedSellableArticles = this.sellableArticles.filter(article => {
                    // pay attention to stock
                    let match = false;
                    article.propertyPivots.forEach(el => {
                        const property = el.property;
                        const value = el.value;

                        if (this.property.id === property.id && value[option.key] === option.value) {
                            match = true;
                        }
                    });
                    return match;
                });

                sellable = !!relatedSellableArticles.length;
            }
            option.sellable = sellable;

            let available = true;
            if (
                this.property.articleRequired &&
                !this.activeOption &&
                this.validArticles &&
                this.validArticles.length
            ) {
                // check if is available
                // ---
                // available means there is some stock
                // for articles with all property values matching the current selection
                // NOTE: keep the cart in mind

                available = false;

                const relatedAvailableArticles = this.validArticles.filter(article => {
                    // pay attention to stock
                    let match = false;
                    article.propertyPivots.forEach(el => {
                        const property = el.property;
                        const value = el.value;

                        if (this.property.id === property.id && value[option.key] === option.value) {
                            match = true;
                        }
                    });
                    return match;
                });

                available = !!relatedAvailableArticles.length;
            }
            option.available = available;
        });

        this.options = Object.freeze(options);
    }
};
</script>

<style lang="sass" scoped>
.label
  font-weight: 500
  // label
  //   padding-bottom: .175em // fix text position
.value
  min-height: 34px
  // padding-left: 2px
  font-weight: 350
  // padding-bottom: .175em // fix text position
  // button
  //   @apply h-8 px-4
  //   padding-bottom: .175em // fix text position
  //   margin: 2px
  //   pointer-events: none
.color-prop
  display: grid
  grid-template-rows: 18px
  grid-template-columns: max-content auto
  grid-gap: 4px
  .tile
    @apply border-1 border-gray-400
    width: 18px
    height: 18px
    display: inline-block
  span
    line-height: 18px
button
  margin: 2px
  .tile
    margin-left: -10px
.is-not-available
  opacity: .5
.options
  margin-left: -2px
</style>
